import React from 'react'
import PropTypes from 'prop-types'

import Accordion from '../../components/Accordion'
import CheckboxFacet from './components/CheckboxFacet'

const SortedList = (props) => {
  const { items, name, handleFacetClick, selectedFacets, isMobile, expanded, facetId } = props

  const headerText = name.includes('.') ? name.split('.')[1] : name
  const isFacetIdEnabled = !!facetId

  const itemsWithFacetId = items.map((item) => ({
    ...item,
    ...(isFacetIdEnabled && { id: facetId }),
  }))

  const sortBySelectedItem = (items, selectedFacets, name, facetId) => {
    let sortedItems = []
    const facetKey = facetId || name
    if (items.length > 0) {
      sortedItems = items
        .map((item) => ({
          ...item,
          checked: !!(selectedFacets[facetKey] && selectedFacets[facetKey].includes(item.name)),
        }))
        .sort((a, b) => b.checked - a.checked)
    }
    return sortedItems
  }

  const sortedItems = sortBySelectedItem(itemsWithFacetId, selectedFacets, name, facetId)

  return (
    items.length > 0 && (
      <Accordion title={headerText} isMobile={isMobile} expanded={expanded}>
        <ul data-testid="product-facets">
          {sortedItems.map((value) => (
            <li
              style={{
                listStyleType: 'none',
              }}
              key={`${name}-${value.name}`}
            >
              <CheckboxFacet
                name={name}
                handleFacetClick={handleFacetClick}
                value={value}
                isMobile={isMobile}
                isFacetIdEnabled={isFacetIdEnabled}
              />
            </li>
          ))}
        </ul>
      </Accordion>
    )
  )
}

export default SortedList

SortedList.defaultProps = {
  items: [],
  name: '',
  selectedFacets: {},
  isMobile: false,
  expanded: true,
  facetId: '',
}

SortedList.propTypes = {
  items: PropTypes.array,
  name: PropTypes.string,
  handleFacetClick: PropTypes.func.isRequired,
  selectedFacets: PropTypes.object,
  isMobile: PropTypes.bool,
  expanded: PropTypes.bool,
  facetId: PropTypes.string,
}
